<template>
    <div class="box">

        <div class="nav">
            <h1 class="title">设备结构虚拟仿真系统</h1>

            <!-- 新增面包屑导航 -->
            <!-- <div class="breadcrumb">
                <span class="breadcrumb-item">首页</span>
                <span class="breadcrumb-divider">-</span>
                <span class="breadcrumb-item">设备结构虚拟仿真系统</span>
                <span class="breadcrumb-divider">-</span>
                <span class="breadcrumb-item active">{{ breadcrumbName }}</span>
            </div> -->

            <!-- 切换菜单 -->
            <div class="text">
                <p class="item" :class="{ active: currentType === 'CT' }" @click="currentType = 'CT'">
                    CT设备结构虚拟仿真系统
                </p>
                <p class="item" :class="{ active: currentType === 'DR' }" @click="currentType = 'DR'">
                    DR设备结构虚拟仿真系统
                </p>
                <p class="item" :class="{ active: currentType === 'MRI' }" @click="currentType = 'MRI'">
                    MRI设备结构虚拟仿真系统
                </p>
            </div>
        </div>

        <!-- 根据类型动态渲染组件 -->
        <div class="component-wrap">
            <deviceCT v-if="currentType === 'CT'" :hidePullDown="true"></deviceCT>
            <deviceDR v-if="currentType === 'DR'" :hidePullDown="true"></deviceDR>
            <deviceMRI v-if="currentType === 'MRI'" :hidePullDown="true"></deviceMRI>
        </div>
    </div>
</template>

<script>
import deviceCT from '@/components/products/deviceCT.vue'
import deviceDR from '@/components/products/deviceDR.vue'
import deviceMRI from '@/components/products/deviceMRI.vue'
export default {
    components: {
        deviceCT,
        deviceDR,
        deviceMRI
    },
    data() {
        return {
            // 默认打开CT页面
            currentType: 'CT',
            // 设备名称映射表，统一管理面包屑文字
            typeNameMap: {
                CT: 'CT设备结构虚拟仿真系统',
                DR: 'DR设备结构虚拟仿真系统',
                MRI: 'MRI设备结构虚拟仿真系统'
            }
        }
    },
    computed: {
        // 计算属性动态获取当前面包屑最后一级名称
        breadcrumbName() {
            return this.typeNameMap[this.currentType]
        }
    }
}
</script>

<style scoped>
/* 外层容器 */
.box {
    width: 100%;
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
    padding: 0 20px;
    border: 1px solid #ccc;
    border-radius: 20px;
}

.nav {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* 大标题美化 */
.title {
    font-size: 32px;
    font-weight: 600;
    background: linear-gradient(90deg, #2b78e4, #43b4ff);
    -webkit-background-clip: text;
    color: transparent;
    letter-spacing: 2px;
    margin: 20px 0 16px; 
    
}

/* 面包屑样式 */
.breadcrumb {
    width: 70%;
    min-width: 700px;
    margin-bottom: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 10px;
}

.breadcrumb-item {
    color: #888;
    cursor: pointer;
}

.breadcrumb-item:hover {
    color: #2b78e4;
}

/* 当前激活面包屑 */
.breadcrumb-item.active {
    color: #2b78e4;
    font-weight: 500;
    cursor: default;
}

.breadcrumb-divider {
    color: #ccc;
}

/* 导航菜单容器 */
.text {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    padding: 12px 0px;
    background: #f5f8ff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(43, 120, 228, 0.1);
}

/* 每个点击选项 */
.item {
    font-size: 14px;
    color: #666;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    user-select: none;
    margin: 0;
}

/* hover悬浮效果 */
.item:hover {
    background: rgba(43, 120, 228, 0.1);
    color: #2b78e4;
}

/* 选中激活样式 */
.item.active {
    background: linear-gradient(90deg, #2b78e4, #43b4ff);
    color: #fff;
    box-shadow: 0 3px 10px rgba(43, 120, 228, 0.3);
}

/* 组件展示区域 */
.component-wrap :deep(.device-ct) {
    margin-top: 0 !important;
}

:deep .device-ct[data-v-64a370b2] {
    padding: 0;
}

:deep .device-ct[data-v-663c1a4f] {
    padding: 0;
}

:deep .device-ct[data-v-3ebb0ad3] {
    padding: 0;
}

</style>